import { fetchApi } from '../api';

export const trackEvent = (eventKey: string, payload: Record<string, unknown> = {}): void => {
  fetchApi('/api/Metric/Log', { eventKey, payload }, 'post').catch(() => { /* fire-and-forget */ });
};
